import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React, {
  Component,
} from 'react';
import Directives from '../../../Directives/Directives';
import classes from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IDropdownField,
} from '../formFields';

interface IProps extends IDropdownField {
  errors: any;
  touched: any;

  onChange(name: string): any;
}

class DropdownField extends Component<IProps> {
  getValue = (selectedKey: any) => selectedKey || '';

  render() {
    console.warn(this.props);
    return (
      <FormControl className={classes.filed}>
        <TextField
          select
          name={this.props.name}
          label={this.props.label}
          className={classes.textField}
          value={this.getValue(this.props.value)}
          onChange={this.props.onChange(this.props.name)}
          SelectProps={{
            MenuProps: {
              className: classes.menu,
            },
          }}
          variant="outlined"
        >
          {this.props.selectList.map((name: any, index: number) => (
            <MenuItem key={name[this.props.selectListKey]} value={name[this.props.selectListKey]}>
              {name[this.props.selectListValue]}
            </MenuItem>
          ))}
        </TextField>
        <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
          <FormHelperText className={classes.error}>{this.props.errors[this.props.name]}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }
}

export default DropdownField;
